// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__18kMT","col":"styles_col__1XCJk"};